import { render, staticRenderFns } from "./URegisterPayment.vue?vue&type=template&id=3f32d3d8&scoped=true&"
import script from "./URegisterPayment.vue?vue&type=script&lang=ts&"
export * from "./URegisterPayment.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterPayment.vue?vue&type=style&index=0&id=3f32d3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32d3d8",
  null
  
)

export default component.exports